import { render, staticRenderFns } from "./nonmoving.vue?vue&type=template&id=408cf7a8&scoped=true"
import script from "./nonmoving.vue?vue&type=script&lang=js"
export * from "./nonmoving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408cf7a8",
  null
  
)

export default component.exports